import React from 'react';

const TermsContent = ({ className }) => {
  return (
    <div className={className}>
      <p>Suspire is a curated health and wellness platform. We work with a select set of brands that align with our standards of quality, trust, and long-term value.</p>
      <p>By submitting your details, you are applying to be considered for onboarding on Suspire.</p>

      <h3>1. Application, Not Onboarding</h3>
      <p>Submitting this form or creating an account:</p>
      <ul>
        <li>Does not confirm onboarding or partnership</li>
        <li>Does not grant selling access on Suspire</li>
      </ul>
      <p>All applications are reviewed internally, and selection is at Suspire&apos;s sole discretion.</p>

      <h3>2. Information You Provide</h3>
      <p>You confirm that:</p>
      <ul>
        <li>All details shared are accurate and complete</li>
        <li>You are authorized to represent the brand</li>
      </ul>
      <p>Any false or misleading information may lead to rejection or removal from consideration.</p>

      <h3>3. Evaluation Process</h3>
      <p>Suspire evaluates brands based on internal criteria including product quality, category fit, and alignment with our platform standards.</p>
      <p>We may accept or decline any application without obligation to provide a reason.</p>

      <h3>4. No Commercial Relationship</h3>
      <p>Submitting your application does not create:</p>
      <ul>
        <li>Any partnership</li>
        <li>Any commercial agreement</li>
        <li>Any rights to sell on Suspire</li>
      </ul>
      <p>If selected, you will be guided through a structured onboarding process, including acceptance of a separate brand agreement governing your relationship with Suspire.</p>

      <h3>5. Data & Communication</h3>
      <ul>
        <li>Your information will be used to review your application and communicate with you</li>
        <li>You may be contacted via email, phone, or messaging platforms</li>
      </ul>
      <p>All data is handled in accordance with Suspire&apos;s Privacy Policy.</p>

      <h3>6. Scope & Market</h3>
      <p>Suspire currently operates within the Indian market.</p>
      <ul>
        <li>International brands may apply if they have an Indian entity, distributor, or operational presence, subject to evaluation</li>
      </ul>

      <h3>7. Limitation of Liability</h3>
      <p>Suspire is not responsible for:</p>
      <ul>
        <li>Application outcomes</li>
        <li>Delays in review</li>
        <li>Any business decisions made based on this application</li>
      </ul>

      <h3>8. Governing Law</h3>
      <p>These terms are governed by the laws of India. Jurisdiction shall lie with courts in Mumbai.</p>

      <h3>Acceptance</h3>
      <p>By proceeding, you confirm that you have read and agree to these terms.</p>
    </div>
  );
};

export default TermsContent;
